import './Double.css';
import './past__round.css';
import { BlockList } from '../../components/windows/BlockList/BlockList';
import doubleBackgroundImg from '../../images/DoubleBackgroundImg.png';
import { Roulette } from '../../components/svg/Roulette';
import { Arrow } from '../../components/svg/Arrow';
import { Title } from '../../components/Title/Title';
import React from 'react';

const buttonsRates: { value: string }[] = [
    {
        value: 'Min',
    },
    {
        value: '+50',
    },
    {
        value: '+100',
    },
    {
        value: '+200',
    },
    {
        value: '+500',
    },
    {
        value: '+1000',
    },
    {
        value: '+2000',
    },
    {
        value: 'x2',
    },
    {
        value: '1/2',
    },
    {
        value: 'Max',
    },
];
const title = 'Дабл';
export const Double = () => {
    return (
        <div className="double">
            <Title title={title} />
            <img src={doubleBackgroundImg} alt="" className="double__background-img" />
            <div className="double__up-container">
                <div className="double__wheel-container">
                    <div className="double__animation-container">
                        <span className="double__animation-number">5</span>
                        <span className="double__text">осталось</span>
                    </div>
                    {/*<img src={arrow} alt="arrow" className="double__arrow" />*/}
                    {/*<img src={wheel} alt="wheel" className="double__wheel" />*/}
                    <Arrow size={75} />
                    <Roulette />
                    {/*<Roulette2 />*/}
                </div>
                <div className="double__form-container">
                    <form className="double__form">
                        <label htmlFor="double_input" className="double__label">
                            Ваш баланс: <span className="double__label-span">150.00</span>
                        </label>
                        <input name="double_input" type="text" className="double__input" />
                        <button className="double__form-button double__form-button_left">x2</button>
                        <button className="double__form-button double__form-button_center">x14</button>
                        <button className="double__form-button double__form-button_right">x2</button>
                    </form>
                    <div className="double__container-button">
                        {buttonsRates.map((value, i) => (
                            <button className="double__rate-button" key={i}>
                                {value.value}
                            </button>
                        ))}
                    </div>
                    <div className="double__past-rounds">
                        <div className="double__past-rounds-info">
                            <span className="double__past-number-rounds">
                                Номер раунда: <span>4515483</span>
                            </span>
                            <span className="double__past-number-rounds">
                                Число раунда: <span>Скрыт</span>
                            </span>
                        </div>
                        <div className="past__round-container">
                            <div className="past__round past__round_black">3</div>
                            <div className="past__round past__round_black">7</div>
                            <div className="past__round past__round_red">4</div>
                            <div className="past__round past__round_black">9</div>
                            <div className="past__round past__round_black">14</div>
                            <div className="past__round past__round_green">11</div>
                            <div className="past__round past__round_black"></div>
                            <div className="past__round past__round_red">2</div>
                            <div className="past__round past__round_black">4</div>
                            <div className="past__round past__round_red">7</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="double__down-container">
                <BlockList />
                <BlockList />
                <BlockList />
            </div>
        </div>
    );
};
